
    export const WAYANG_CHARACTERS = {};
    export const WAYANG_MAP = {};
    export const KATEGORI_LIST = ['Pandawa', 'Punakawan', 'Anak Pandawa', 'Dewa', 'Pelengkap'];
    const _getWayangDs = (ds) => ds || (typeof globalThis !== 'undefined' && globalThis._currentWayangData) || null;
    export const getActiveWayangList = (ds) => {
      const d = _getWayangDs(ds);
      if (!d) return [];
      if (Array.isArray(d)) return d;
      if (Array.isArray(d.wayang_list)) return d.wayang_list;
      return [];
    };
    export const getActiveKategoriList = (ds) => {
      const d = _getWayangDs(ds);
      if (d && Array.isArray(d.kategori_list) && d.kategori_list.length > 0) return d.kategori_list;
      return ['Pandawa', 'Punakawan', 'Anak Pandawa', 'Dewa', 'Pelengkap'];
    };
  